import { render, staticRenderFns } from "./InitialIssuancePartnerForm.vue?vue&type=template&id=6f5c9507&lang=en"
import script from "./InitialIssuancePartnerForm.vue?vue&type=script&lang=js"
export * from "./InitialIssuancePartnerForm.vue?vue&type=script&lang=js"
import style0 from "./InitialIssuancePartnerForm.vue?vue&type=style&index=0&id=6f5c9507&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports